import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select, SelectProps, Spin } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import React from "react";
import { Link } from "react-router-dom";
import PayrollYearlySettingsService from "../../Services/PayrollYearlySettingsService";
import { adminContext } from "../../Common/PageRoute";
import dayjs from "dayjs";
import AddPayrollYearlySettings from "./AddPayrollYearlySettings";
import { PageHeader } from "../../Common/MainLayout";
import { useUser } from "../../Context/UserContext";
import CommonService from "../../Services/CommonService";
import { IPagingPagingItems } from "../../Common/CommonComponent";

const { Search } = Input;
interface ListDataType {
  key: React.Key;
  id: number;
  yearId: number;
  defaultTaxCode: string;
  statePensionAge: string;
  sspWkPay: number;
  sapawePay: number;
  smpawePay: number;
  ppBirthAWEPay: number;
  ppAdoptionAWEPay: number;
  eaLimit: number;
  awe: number;
  pensionLowerLimit: number;
  pensionUpperLimit: number;
  taTaxableFrom: number;
  createdBy: any;
}

const PayrollYearlySettings = () => {
  const { isSubAdmin } = useUser()
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);
  const [dialog, setDialog] = React.useState({ type: "", params: {} });
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
  const [selectedYearlySettings, setSelectedYearlySettings] =
    React.useState<ListDataType>();
  const [payrollYearlySettings, setPayrollYearlySettings] = React.useState<ListDataType[]>([]);
  const [pagingItems, setPagingItems] = React.useState<IPagingPagingItems>({
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
  });
  const [listParams, setListParams] = React.useState({
    search: "",
    sortDir: "descend",
    sortCol: "_id",
    yearId: undefined,
  });
  const [refresh, setRefresh] = React.useState(false);
  const [selYearOptions, setSelYearOptions] = React.useState<SelectProps["options"]>([]);
  const [yearIds, setYearIds] = React.useState<number[]>([]);

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "Sno",
      align: "center",
      width: "3%",
      render: (_: any, record: any, index: any) => <p style={{ marginLeft: -10 }}>{index + 1}</p>,
    },
    {
      title: "Year ID",
      dataIndex: "id",
      key: "_id",
      sorter: true,
      width: "6%",
      render: (text: any, record: any) => (
        <Link title={text} to={`/payrollyearlysettings/${record.id}`}>
          {text ?? record?.yearId}
        </Link>
      ),
    },
    {
      title: "Tax code",
      dataIndex: "defaultTaxCode",
      key: "DefaultTaxCode",
      width: "5%",
    },
    {
      title: "State PA",
      dataIndex: "statePensionAge",
      key: "StatePensionAge",
      width: "5%",
    },
    {
      title: "Pension LL",
      dataIndex: "pensionLowerLimit",
      key: "PensionLowerLimit",
      width: "6%",
    },
    {
      title: "Pension UL",
      dataIndex: "pensionUpperLimit",
      key: "PensionUpperLimit",
      width: "6%",
    },
    {
      title: "EA limit",
      dataIndex: "eaLimit",
      key: "EALimit",
      width: "5%",
    },
    {
      title: "AWE",
      dataIndex: "awe",
      key: "AWE",
      width: "4%",
    },
    {
      title: "SSP WP",
      dataIndex: "sspWkPay",
      key: "SSPWKPay",
      width: "5%",
    },
    {
      title: "SAP AWE pay",
      dataIndex: "sapawePay",
      key: "SAPAWEPay",
      width: "7%",
    },
    {
      title: "SMP AWE pay",
      dataIndex: "smpawePay",
      key: "SMPAWEPay",
      width: "7%",
    },
    {
      title: "PP birth AWE pay",
      dataIndex: "ppBirthAWEPay",
      key: "PPBirthAWEPay",
      width: "9%",
    },
    {
      title: "PP adoption AWE pay",
      dataIndex: "ppAdoptionAWEPay",
      key: "PPAdoptionAWEPay",
      width: "10%",
    },
    {
      title: "TA taxable form",
      dataIndex: "taTaxableFrom",
      key: "TATaxableFrom",
      width: "9%",
    },
    {
      title: "Created on",
      dataIndex: "createdBy.date",
      key: "CreatedBy.date",
      render: (text: any, record: any) => {
        console.log("date", record.createdBy?.date);
        return (
          <div>{dayjs(record?.createdBy?.date).format("DD-MM-YYYY")}</div>
        )
      },
    },
  ];

  const getItems = async (start: any, length: any) => {
    let res = await PayrollYearlySettingsService.getPayrollYearlySettingsList(
      start,
      length,
      listParams.search,
      listParams.sortCol,
      listParams.sortDir,
      listParams.yearId
    );
    if (res?.status) {
      setLoading(false);
      var data: ListDataType[] = res?.result?.items.map((item: any) => {
        var itemWithKey = {
          key: item?.id,
          id: item?.id,
          yearId: item?.yearId,
          defaultTaxCode: item?.defaultTaxCode,
          statePensionAge: item?.statePensionAge,
          sspWkPay: item?.sspWkPay,
          sapawePay: item?.sapawePay,
          smpawePay: item?.smpawePay,
          ppBirthAWEPay: item?.ppBirthAWEPay,
          ppAdoptionAWEPay: item?.ppAdoptionAWEPay,
          eaLimit: item?.eaLimit,
          awe: item?.awe,
          pensionLowerLimit: item?.pensionLowerLimit,
          pensionUpperLimit: item?.pensionUpperLimit,
          taTaxableFrom: item?.taTaxableFrom,
          createdBy: item?.createdBy,
        };
        return itemWithKey;
      });
      setPayrollYearlySettings(data);
      setPagingItems({
        totalRecords: res?.result?.totalRecords,
        currentPage: pagingItems.currentPage,
        pageSize: pagingItems.pageSize,
      });
    } else {
      openNotification("error", res.message);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    //getItems();
    setLoading(true);
    getItems(
      (pagingItems.currentPage - 1) * pagingItems.pageSize,
      pagingItems.pageSize
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listParams, refresh]);

  React.useEffect(() => {
    const getTaxRatesAddedYears = async () => {
      let res = await CommonService.getPayeollYearlyAddedYear();
      const optn: SelectProps["options"] = [];
      if (res.result) {
        // setPayeAddedYears(res.result);
        let addedYears = res.result;
        let startYear = Math.min(...addedYears);
        let endYear = Math.max(...addedYears) + 10;
        for (let i = startYear; i <= endYear; i++) {
          // console.log("years", addedYears);
          optn.push({
            value: i,
            label: `${1999 + i} - ${2000 + i}`,
            disabled: addedYears?.includes(i) ? true : false,
          });
        }
        setSelYearOptions(optn);
        setYearIds(addedYears);
      }
    };
    getTaxRatesAddedYears();
  }, []);

  const setListParamsAndRefresh = (key: any, value: any) => {
    setPagingItems({ ...pagingItems, currentPage: 1, pageSize: 15 })
    setListParams((p: any) => ({ ...p, [key]: value }));
  };

  return (
    <Row justify="start" align="middle" style={{ height: 100 }}>
      {/* <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      > */}
      <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
        <PageHeader
          item={[
            {
              label: "Payroll Yearly Settings",
              path: "/payrollyearlysettings",
            },
          ]}
          style={{ color: "#172B4D" }}
        />
      </Row>
      <Row
        className="p-3"
        style={{
          backgroundColor: "white",
          //minHeight: window?.outerHeight - 196.6,
        }}
      >
        {
          !isSubAdmin() ?
            <Col span={24}>
              <Row gutter={[8, 8]} align="middle" className="pb-3">

                {/* ================= ADD ================= */}
                <Col xs={24} sm={12} md={7} lg={6} xl={5} xxl={4}>
                  <Button
                    type="primary"
                    // className="add-btn"
                    block
                    onClick={() => {
                      setDialog({ type: "addYearlySettings", params: {} });
                    }}
                  >
                    <PlusOutlined />
                    {selectedRowKeys.length === 1
                      ? "Clone payroll yearly settings"
                      : "Payroll yearly settings"}
                  </Button>
                </Col>

                {/* ================= SEARCH ================= */}
                <Col xs={24} sm={12} md={{ span: 5, offset: 5 }} lg={{ span: 4, offset: 8 }} xl={{ span: 4, offset: 10 }} xxl={{ span: 3, offset: 13 }}>
                  <Search
                    placeholder="Search"
                    // className="att-search-input mb-1 me-5"
                    onSearch={(val: string) =>
                      setListParams({ ...listParams, search: val })
                    }
                    onChange={(e) =>
                      e.target.value === ""
                        ? setListParams({ ...listParams, search: "" })
                        : null
                    }
                  />
                </Col>

                {/* ================= PRACTICES ================= */}
                <Col xs={24} sm={24} md={7} lg={6} xl={5} xxl={4}>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Select Year"
                    maxTagCount="responsive"
                    style={{ width: "100%" }}
                    value={listParams.yearId}
                    onChange={(val) => setListParamsAndRefresh("yearId", val)}
                    filterOption={(input, option) =>
                      (option?.label?.toString() ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={yearIds.map((yearId) => ({
                      value: yearId,
                      label: `${1999 + yearId} - ${2000 + yearId}`,
                    }))}
                  />
                </Col>
              </Row>
            </Col>
            : null
        }
        <Col span={24}
        // style={{ minHeight: window.outerHeight - 200 }}
        >
          <>
            <Table
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                onSelect: (record: ListDataType) => {
                  let selItems: React.Key[] = [];
                  if (!selectedRowKeys.includes(record?.id)) {
                    selItems.push(record?.id);
                  }
                  setSelectedRowKeys(selItems);
                  setSelectedYearlySettings(record);
                },
              }}
              locale={{
                triggerDesc: "",
                triggerAsc: "",
                cancelSort: "",
              }}
              // rowClassName={(record:any) => record?.id !== selectedRowKeys  ? "disabled-row" : ""}
              dataSource={payrollYearlySettings}
              columns={columns}
              size="small"
              className="border-top-table"
              loading={{ spinning: loading, indicator: <Spin indicator={<LoadingOutlined />} /> }}
              scroll={{ x: 700, y: window.innerHeight - 256 }}
              pagination={{
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                current: pagingItems.currentPage,
                pageSize: pagingItems.pageSize,
                showSizeChanger: true,
                total: pagingItems.totalRecords,
                pageSizeOptions: ["1", "15", "25", "50", "100"],
              }}
              onChange={(paging, filter, sort: any) => {
                sort.order !== undefined &&
                  setListParams(prev => ({
                    ...prev,
                    sortDir: sort.order,
                    sortCol: sort.columnKey,
                  }));
                if (
                  paging?.current !== undefined &&
                  paging?.pageSize !== undefined
                ) {
                  setLoading(true);
                  setPagingItems((p) => {
                    p.currentPage =
                      paging.current !== undefined ? paging.current : 1;
                    p.pageSize =
                      paging.pageSize !== undefined ? paging.pageSize : 15;
                    return p;
                  });
                  getItems(
                    (paging.current - 1) * paging.pageSize,
                    paging.pageSize
                  );
                }
              }}
            />
          </>
        </Col>
      </Row>
      {dialog.type === "addYearlySettings" && (
        <AddPayrollYearlySettings
          id={selectedRowKeys[0]}
          record={selectedYearlySettings}
          onDismiss={(conformation: boolean) => {
            setDialog({ type: "", params: {} });
            if (conformation) {
              setRefresh((x) => (x = !x));
            }
          }}
          selYearOptions={selYearOptions}
        />
      )}
      {/* </Spin> */}
    </Row>
  );
};

export default PayrollYearlySettings;
